import { AddRoleWithSubtemplateButton } from "PFApp/components/activity_commons/add_role_with_subtemplate_button";
import { NO_SUBTEMPLATE_VALUE } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Inline, Stack } from "PFComponents/containers";
import { Divider } from "PFComponents/divider";
import { Typography } from "PFComponents/typography";
import { Subtemplate } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../apply_engagement_blueprint_page.module.scss";

type ToolbarProps = {
  rolesCount: number;
  addRoleInSubtemplate: (subtemplateKey?: string) => void;
  blueprintName: string;
};

export const Toolbar = ({ rolesCount, addRoleInSubtemplate, blueprintName }: ToolbarProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });

  return (
    <Stack className={css.toolbar} gap="spacingLg">
      <Stack>
        <Typography variant="labelRegular">{t("label")}</Typography>
        <Typography variant="bodyBold">{blueprintName}</Typography>
        <Divider />
      </Stack>
      <Inline spread>
        <Typography variant="bodyRegular">{t("rolesCount", { count: rolesCount })}</Typography>
        <Inline gap="spacingSm">
          <AddRoleWithSubtemplateButton
            buttonKind="secondary"
            onChange={(subtemplate?: Subtemplate) => {
              addRoleInSubtemplate(subtemplate?.subtemplate_key ?? NO_SUBTEMPLATE_VALUE);
            }}
          />
        </Inline>
      </Inline>
    </Stack>
  );
};
